import styled from '@emotion/styled';
import React from 'react';
import Box from '@ff/ui/Box';
import Text from '@ff/ui/Text';

export interface Props {
  title?: string;
  subtitle?: string;
  description?: string;
}

export default function DetailSection(props: Props) {
  const { title, subtitle, description } = props;

  const hasContent = title || subtitle || description;

  if (!hasContent) return null;

  return (
    <Container>
      <TitleContainer>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {title && <Title>{title}</Title>}
      </TitleContainer>
      <Description>{description}</Description>
    </Container>
  );
}

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',

  [theme.mediaQueries.md]: {
    flexDirection: 'row',
  },
}));

const TitleContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '24px',
  width: 'min(460px, 80vw)',
});

const Title = styled(Text)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '30px',
  color: theme.colors.white,

  [theme.mediaQueries.md]: {
    fontSize: '28px',
    lineHeight: '26px',
    marginRight: '20px',
  },
}));

const Subtitle = styled(Text)(({ theme }) => ({
  fontWeight: theme.fontWeights.light,
  fontSize: 17,
  lineHeight: '26px',
  marginBottom: '6px',
  color: theme.colors.white
}));

const Description = styled(Text)(({ theme }) => ({
  fontWeight: theme.fontWeights.light,
  fontSize: 14,
  lineHeight: '22px',
  maxWidth: '690px',
  color: theme.colors.white,
}));
